import { Lock } from "lucide-react";

export default function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6">
      <div className="text-center" data-testid="not-found">
        <div
          className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl"
          style={{ backgroundColor: "var(--fc-surface2)" }}
        >
          <Lock size={22} style={{ color: "var(--fc-secondary-text)" }} />
        </div>
        <h1 className="font-serif text-2xl font-semibold text-foreground">Page introuvable</h1>
        <p className="mt-2 max-w-sm text-sm" style={{ color: "var(--fc-secondary-text)" }}>
          Cette adresse n'existe pas ou n'est plus disponible. Si vous cherchez à accéder à un outil
          confidentiel, utilisez le lien exact qui vous a été communiqué.
        </p>
      </div>
    </div>
  );
}
